// jwt.interceptor.ts
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Token } from '../models/token';
import { StoragePortalService } from '../services/storage-portal.service';
import { ApiUrlService } from '../services/api-url.service';
import { RmmMfaStateService } from '../services/rmm-mfa-state.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private storage: StoragePortalService,
    private router: Router,
    private api: ApiUrlService,
    private mfa: RmmMfaStateService
  ) {}

 intercept(
  request: HttpRequest<unknown>,
  next: HttpHandler
): Observable<HttpEvent<unknown>> {
  // 1) Detectar si es flujo de auth
  const url = request.url;
  const isRmm = url.startsWith(`${this.api.rmmApi}/`) || url.startsWith(`${this.api.hfappApi}/`);
  if (isRmm && !this.mfa.valid) {
    this.mfa.lock();
    return throwError(() => ({ status: 403, error: { detail: { code: 'RMM_MFA_REQUIRED' } } }));
  }
  const isAuthFlow =
    url.endsWith('/token') ||
    url.endsWith('/status') ||
    url.endsWith('/user-info-recover');

  // 2) Leer token y clonar
  const token = this.storage.token;
  let cloneReq = request;
  if (token?.access_token && !url.endsWith('/token')) {
    cloneReq = request.clone({
      setHeaders: {
        Authorization: `${token.token_type} ${token.access_token}`
      }
    });
  }

  if (isRmm && this.mfa.token) {
    cloneReq = cloneReq.clone({ setHeaders: { 'X-RMM-MFA': this.mfa.token } });
  }



  return next.handle(cloneReq).pipe(
    tap(() => {
      // Discard sensitive responses arriving after the access window closes.
      if (isRmm && !this.mfa.valid) {
        this.mfa.lock();
        throw { status: 403, error: { detail: { code: 'RMM_MFA_REQUIRED' } } };
      }
    }),
    catchError(err => {
      if (isRmm && err.error?.detail?.code === 'RMM_MFA_REQUIRED') this.mfa.lock();
      if (err.status === 403 && err.error?.detail?.code === 'PASSWORD_CHANGE_REQUIRED') {
        this.router.navigate(['/cambiar-contrasena']);
      }
      if (err.status === 401) {
        if (!isAuthFlow) {
          this.storage.clearToken();
          this.router.navigate(['/login-portal']);
        }
        return throwError(() => err);
      }
      return throwError(() => err);
    })
  );
}
}
